import { useEffect, useState } from 'react';

const useModalAdaptSize = props => {
    const { maxWidth = 1200, maxHeight = 876, minWidth = 900, minHeight = 630, padding = 80 } = props;
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();
    useEffect(() => {
        _adaptSize();
        window.addEventListener('resize', _adaptSize);
        return () => {
            window.removeEventListener('resize', _adaptSize);
        };
    }, []);

    const _adaptSize = () => {
        const ratio = maxWidth / maxHeight;

        // 计算可视区域的最大宽度和高度
        const maxViewWidth = window.innerWidth - padding * 2;
        const maxViewHeight = window.innerHeight - padding * 2;

        // 根据屏幕比例计算初始宽高
        let calculatedWidth = maxViewWidth;
        let calculatedHeight = maxViewHeight;

        // 按比例调整宽高
        if (maxViewWidth / maxViewHeight > ratio) {
            calculatedWidth = maxViewHeight * ratio;
        } else {
            calculatedHeight = maxViewWidth / ratio;
        }

        // 确保不超过最大值
        calculatedWidth = Math.min(calculatedWidth, maxWidth);
        calculatedHeight = Math.min(calculatedHeight, maxHeight);

        // 确保不小于最小值
        calculatedWidth = Math.max(calculatedWidth, minWidth);
        calculatedHeight = Math.max(calculatedHeight, minHeight);

        // 最后再次确保比例正确
        if (calculatedWidth / calculatedHeight > ratio) {
            calculatedWidth = calculatedHeight * ratio;
        } else if (calculatedWidth / calculatedHeight < ratio) {
            calculatedHeight = calculatedWidth / ratio;
        }

        setWidth(Math.floor(calculatedWidth));
        setHeight(Math.floor(calculatedHeight));
    };

    return {
        width,
        height,
    };
};

export default useModalAdaptSize;
